// Every ops object's record page and list layout, as @olytic/foundation ObjectMetadata,
// designed by the rules in olytic-ui docs/patterns/record-page.md. Each
// definition has its rationale beside it (<key>.md).
import type { ObjectMetadata } from '@olytic/foundation';

import type { ObjectKey } from '../../navigation';
import { accounts } from './accounts';
import { activities } from './activities';
import { audiences } from './audiences';
import { billingAccounts } from './billing-accounts';
import { billingPolicies } from './billing-policies';
import { billingSchedules } from './billing-schedules';
import { billingTreatmentItems } from './billing-treatment-items';
import { billingTreatments } from './billing-treatments';
import { contracts } from './contracts';
import { contacts } from './contacts';
import { documents } from './documents';
import { guidelines } from './guidelines';
import { invoiceLines } from './invoice-lines';
import { invoiceRuns } from './invoice-runs';
import { invoices } from './invoices';
import type { Row } from './kit';
import { leads } from './leads';
import { meetings } from './meetings';
import { opportunities } from './opportunities';
import { opportunityContacts } from './opportunity-contacts';
import { dealRetros } from './deal-retros';
import { agentConversations } from './agent-conversations';
import { researchFigures } from './research-figures';
import { researchFindings } from './research-findings';
import { researchSources } from './research-sources';
import { deliverableTypes } from './deliverable-types';
import { deliverables } from './deliverables';
import { guides } from './guides';
import { people } from './people';
import { projects } from './projects';
import { assets } from './assets';
import { prices } from './prices';
import { productGroups } from './product-groups';
import { products } from './products';
import { priceGridCells } from './price-grid-cells';
import { priceGrids } from './price-grids';
import { productOptions } from './product-options';
import { productResourceRoles } from './product-resource-roles';
import { quotes } from './quotes';
import { resourceAssignments } from './resource-assignments';
import { resourceCapacity } from './resource-capacity';
import { resourceRoles } from './resource-roles';
import { revenue } from './revenue';
import { timeEntries } from './time-entries';
import { userResourceRoles } from './user-resource-roles';

export const objects: Record<ObjectKey, ObjectMetadata<Row>> = {
  leads,
  accounts,
  contacts,
  opportunities,
  audiences,
  projects,
  'time-entries': timeEntries,
  meetings,
  activities,
  documents,
  products,
  'product-groups': productGroups,
  prices,
  quotes,
  assets,
  revenue,
  'product-options': productOptions,
  'price-grids': priceGrids,
  'price-grid-cells': priceGridCells,
  invoices,
  'invoice-lines': invoiceLines,
  'invoice-runs': invoiceRuns,
  'billing-schedules': billingSchedules,
  'billing-accounts': billingAccounts,
  'billing-policies': billingPolicies,
  'billing-treatments': billingTreatments,
  'billing-treatment-items': billingTreatmentItems,
  contracts,
  guidelines,
  'resource-roles': resourceRoles,
  'product-resource-roles': productResourceRoles,
  people,
  'user-resource-roles': userResourceRoles,
  'resource-capacity': resourceCapacity,
  'resource-assignments': resourceAssignments,
  'opportunity-contacts': opportunityContacts,
  'deal-retros': dealRetros,
  'agent-conversations': agentConversations,
  'research-sources': researchSources,
  'research-findings': researchFindings,
  'research-figures': researchFigures,
  'deliverable-types': deliverableTypes,
  deliverables,
  guides,
};
